import React from 'react';
import { IMapInfo } from '../../../services/cayuga/types';
import './style.scss';

interface IProps {
  element: IMapInfo,
  onLayerSelect: (el: IMapInfo) => void
  onCameraSelect: (el: IMapInfo) => void
  onMapSelect: (el: IMapInfo) => void
  onWebPageSelect: (el: IMapInfo) => void
  onTriggerSelect: (el: IMapInfo) => void
}

const MapElementComponent: React.FC<IProps> = ({element, onLayerSelect, onCameraSelect, onMapSelect, onWebPageSelect, onTriggerSelect}) => {
  const left = parseFloat(element["a:X"]) * 100 + '%';
  const top = parseFloat(element["a:Y"]) * 100 + '%';
  const size = parseFloat(element["a:Size"]) * 20 + 'px';

  const handler = () => {
    switch (element["a:EntityType"]) {
      case 'Layer':
        onLayerSelect(element);
        break;
      case 'Camera':
        onCameraSelect(element);
        break;
      case 'Map':
        onMapSelect(element);
        break;
      case 'WebPage':
        onWebPageSelect(element);
        break;
      case 'Button':
        onTriggerSelect(element);
        break;
      default:
        break;
    }
  }
  const GetFieldOfView = (fieldOfView: string) => {
    const radius = 25;
    const width = 2 * Math.PI * radius;
    const result = (width * (100 / (360 / parseInt(fieldOfView)))) / 100;
    return `${result},${width}`;
  }

  return (
    <div onClick={handler}
         className={`mapElement ${element["a:ShowLabelAlways"] === 'true' ? 'showLabel' : ''}`}
         id={element["a:EntityID"]}
         style={{
           left: left,
           top: top,
           width: size,
           height: size,
         }}
    >
      {
        (element['a:EntityType'] === 'Camera' && element['a:FieldOfView'])
        && <div className="svgWrapper">
          <svg className='cameraViewSector'
               width="100px"
               height="100px"
               viewBox="0 0 100 100"
               preserveAspectRatio="xMidYMid meet"
               style={{transform: `rotate(${element["a:RotationAngle"]}deg)`}}
          >
            <circle className="sector" strokeDasharray={GetFieldOfView(element['a:FieldOfView'])} r="25" cx="50"
                    cy="50"/>
          </svg>
        </div>
      }
      <div className={'title'}>{element["a:Label"]}</div>
      <img src={`data:image/png;base64,${element["a:Icon"]}`}
           alt={element["a:Label"]}
           style={{transform: `rotate(${element['a:EntityType'] === 'Camera' ? element["a:RotationAngle"] : '0'}deg)`}}
      />
    </div>
  )
};


export default MapElementComponent;